import { Component, Input, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Subscription } from "rxjs";
import { GroupsService } from "../../..";
import { UserService } from "../../../../../shared";
import { StudentGroupsTableRefreshService } from "../shared/student-groups-table-refresh.service";
import { DeleteFineWarningComponent } from "./delete-fine-warning/delete-fine-warning.component";
import { DeleteIncidentWarningComponent } from "./delete-incident-warning/delete-incident-warning.component";
import { GroupActionPickerComponent } from "./group-action-picker/group-action-picker.component";
import { SGEditIncidentComponent } from "./sgedit-incident/sgedit-incident.component";
import { SGEditReleaseComponent } from "./sgedit-release/sgedit-release.component";
import * as moment from "moment";
import { DeleteReminderWarningComponent } from "./delete-reminder-warning/delete-reminder-warning.component";
import { SGEditReminderComponent } from "./sgedit-reminder/sgedit-reminder.component";

@Component({
	selector: "caass-group-action-table",
	templateUrl: "./group-action-table.component.html",
	styleUrls: ["./group-action-table.component.css"],
})
export class GroupActionTableComponent implements OnInit {
	constructor(
		private userService: UserService,
		private GroupActionTableService: GroupsService,
		private dialogService: DialogService,
		private refreshService: StudentGroupsTableRefreshService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadGroupAction();

		this.subscription = this.refreshService.onGroupActionRefresh().subscribe((refresh) => {
			refresh.toString(); //
			this.loadGroupAction();
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: Subscription; //Used to update

	@Input() SchoolID: any;
	@Input() SelectedGroup: any;

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	ActionDisplayOption: string = "DateRange";

	isProcessing: boolean = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedGroupAction: any;
	lstGroupAction: any = [];

	//Filter lists
	lstStartDateDesc: any = [];
	lstEndDateDesc: any = [];
	lstGroupActionTypeDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "GroupActionTypeDesc", header: "Action Type" },
		{ field: "Description", header: "Description" },
		{ field: "IncidentDTDesc", header: "Action Date" },
		{ field: "StartDateDesc", header: "Start Date" },
		{ field: "EndDateDesc", header: "End Date" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadGroupAction() {
		if (this.ActionDisplayOption == "All") {
			this.loadAll();
		} else {
			this.loadDateRange();
		}
	}

	loadAll() {
		this.loading = true;

		var result = this.GroupActionTableService.GroupActionsGetListAll(this.SelectedGroup.GroupID);
		result.subscribe(
			(response) => {
				this.lstGroupAction = response;

				//Load Data Filter Lists
				for (var i = 0; i < this.lstGroupAction.length; i++) {
					var next = this.lstGroupAction[i];

					next.IncidentDTDesc = next.IncidentDT == "0001-01-01T00:00:00" ? "" : moment(new Date(next.IncidentDT)).format("MM/DD/YYYY h:mm a");
					next.StartDateDesc = next.StartDate == "0001-01-01T00:00:00" ? "" : moment(new Date(next.StartDate)).format("MM/DD/YYYY");
					next.EndDateDesc = next.EndDate == "0001-01-01T00:00:00" ? "" : moment(new Date(next.EndDate)).format("MM/DD/YYYY");
				}

				this.lstGroupActionTypeDesc = Array.from(new Set(this.lstGroupAction.map((item: any) => item.GroupActionTypeDesc))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}

	loadDateRange() {
		this.loading = true;

		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.loading = false;
			return;
		}

		var result = this.GroupActionTableService.GroupActionsGetList(this.SelectedGroup.GroupID, fsDate, feDate);
		result.subscribe(
			(response) => {
				this.lstGroupAction = response;

				//Load Data Filter Lists
				for (var i = 0; i < this.lstGroupAction.length; i++) {
					var next = this.lstGroupAction[i];

					next.IncidentDTDesc = next.IncidentDT == "0001-01-01T00:00:00" ? "" : moment(new Date(next.IncidentDT)).format("MM/DD/YYYY h:mm a");
					next.StartDateDesc = next.StartDate == "0001-01-01T00:00:00" ? "" : moment(new Date(next.StartDate)).format("MM/DD/YYYY");
					next.EndDateDesc = next.EndDate == "0001-01-01T00:00:00" ? "" : moment(new Date(next.EndDate)).format("MM/DD/YYYY");
				}

				this.lstGroupActionTypeDesc = Array.from(new Set(this.lstGroupAction.map((item: any) => item.GroupActionTypeDesc))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadGroupAction();
	}

	//Custom Button Methods
	onAddAction() {
		this.errorMessage = "";

		var ref = this.dialogService.open(GroupActionPickerComponent, {
			header: "Add Action",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SchoolID: this.SchoolID,
				SelectedGroup: this.SelectedGroup,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadGroupAction();
			}
		});
	}

	onEditAction() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedGroupAction == undefined) {
			this.errorMessage = "Select a group action to edit";
			return;
		}

		//Open popup based on type of group action
		if (this.SelectedGroupAction.GroupActionTypeID == 1) {
			var ref = this.dialogService.open(SGEditIncidentComponent, {
				header: "Edit Incident Group Action",
				width: "fit-content",
				data: {
					//INSERT Custom Data here
					GroupActionID: this.SelectedGroupAction.GroupActionID,
					user: this.user,
					SchoolID: this.SchoolID,
					SelectedGroup: this.SelectedGroup,
				},
			});
			ref.onClose.subscribe((response) => {
				if (response == 1) {
					this.onRowUnselect(null);
					this.loadGroupAction();
				}
			});
		} else if (this.SelectedGroupAction.GroupActionTypeID == 2) {
			var ref = this.dialogService.open(SGEditReleaseComponent, {
				header: "Edit Group Release",
				width: "fit-content",
				data: {
					//INSERT Custom Data here
					SelectedGroupAction: this.SelectedGroupAction,
					user: this.user,
					SchoolID: this.SchoolID,
					SelectedGroup: this.SelectedGroup,
				},
			});
			ref.onClose.subscribe((response) => {
				if (response == 1) {
					this.onRowUnselect(null);
					this.loadGroupAction();
				}
			});
		} else if (this.SelectedGroupAction.GroupActionTypeID == 5) {
			var ref = this.dialogService.open(SGEditReminderComponent, {
				header: "Edit Reminder",
				width: "fit-content",
				data: {
					//INSERT Custom Data here
					GroupActionID: this.SelectedGroupAction.GroupActionID,
					user: this.user,
					SchoolID: this.SchoolID,
					SelectedGroup: this.SelectedGroup,
				},
			});
			ref.onClose.subscribe((response) => {
				if (response == 1) {
					this.onRowUnselect(null);
					this.loadGroupAction();
				}
			});
		}
	}

	onDeleteAction() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedGroupAction == undefined) {
			this.errorMessage = "Select a group action to delete";
			return;
		}

		//Pick which delete method to call

		//Incident
		if (this.SelectedGroupAction.GroupActionTypeID == 1) {
			//Dialog
			var ref = this.dialogService.open(DeleteIncidentWarningComponent, {
				header: "Delete Group Action",
				width: "fit-content",
				data: {},
			});
			ref.onClose.subscribe((response) => {
				if (response != -1) {
					this.FinishIncidentDelete(response);
				}
			});
		}

		//Early Release
		else if (this.SelectedGroupAction.GroupActionTypeID == 2) {
			//Dialog
			//Same as incident
			var ref = this.dialogService.open(DeleteIncidentWarningComponent, {
				header: "Delete Group Action",
				width: "fit-content",
				data: {},
			});
			ref.onClose.subscribe((response) => {
				if (response != -1) {
					this.FinishReleaseDelete(response);
				}
			});
		}

		//Fine
		else if (this.SelectedGroupAction.GroupActionTypeID == 3) {
			//Dialog
			var ref = this.dialogService.open(DeleteFineWarningComponent, {
				header: "Delete Group Action",
				width: "fit-content",
				data: {},
			});
			ref.onClose.subscribe((response) => {
				if (response != -1) {
					this.FinishFineDelete(response);
				}
			});
		}

		//Reminder
		else if (this.SelectedGroupAction.GroupActionTypeID == 5) {
			//Dialog
			var ref = this.dialogService.open(DeleteReminderWarningComponent, {
				header: "Delete Reminder",
				width: "fit-content",
				data: {},
			});
			ref.onClose.subscribe((response) => {
				if (response != -1) {
					this.FinishReminderDelete(response);
				}
			});
		}
	}

	FinishIncidentDelete(RemoveDetails) {
		this.loading = true;

		var result = this.GroupActionTableService.GroupActionIncidentDelete(this.SelectedGroupAction.GroupActionID, RemoveDetails);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadGroupAction();
				} else {
					this.loading = false;

					//Fail Dialog
					this.confirmationService.confirm({
						key: "groupaction",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the Group Action",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	FinishReleaseDelete(RemoveDetails) {
		var result = this.GroupActionTableService.GroupActionReleaseScheduleDelete(this.SelectedGroupAction.GroupActionID, RemoveDetails);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadGroupAction();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "groupaction",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the Group Action",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	FinishFineDelete(RemoveDetails) {
		var result = this.GroupActionTableService.GroupActionFineDelete(this.SelectedGroupAction.GroupActionID, RemoveDetails);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadGroupAction();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "groupaction",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the Group Action",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	FinishReminderDelete(RemoveFromStudents) {
		var result = this.GroupActionTableService.GroupActionReminderDelete(this.SelectedGroupAction.GroupActionID, RemoveFromStudents);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					this.loadGroupAction();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "groupaction",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the Group Action: " + response.Message,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onVoidPBIS() {
		this.errorMessage = "";

		if (this.SelectedGroupAction == undefined || this.SelectedGroupAction.GroupActionTypeID != 4) {
			this.errorMessage = "Select a transaction to void/ignore";
			return;
		}

		if (this.SelectedGroupAction.IsVoid == 1) {
			this.errorMessage = "Cannot void/ignore a voided transaction";
			return;
		}

		this.confirmationService.confirm({
			key: "group",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Do you want to void/ignore this transaction?",
			header: "Confirm Void Transaction",
			icon: "fa",
			accept: () => {
				this.FinishVoid();
			},
		});
	}

	FinishVoid() {
		this.isProcessing = true;

		var result = this.GroupActionTableService.GroupPointsVoid(this.SelectedGroupAction.PointsGroupTransactionID);
		result.subscribe(
			(response: any) => {
				this.isProcessing = false;

				if (response.IsError == false) {
					this.onRowUnselect(null);
					this.loadGroupAction();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "group",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not void/ignore the transaction: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.isProcessing = false;
						},
					});
				}
			},
			(error) => {
				this.isProcessing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onActionDisplayOptionChange(val) {
		this.ActionDisplayOption = val;

		this.loadGroupAction();
	}

	onStartDateChange(val) {
		this.StartDate = val;

		this.loadGroupAction();
	}

	onEndDateChange(val) {
		this.EndDate = val;

		this.loadGroupAction();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedGroupAction = val.data;
	}
	onRowUnselect(val) {
		this.SelectedGroupAction = null;
	}
	onRowDblClick(GroupAction) {
		this.SelectedGroupAction = GroupAction;

		if (this.EnableEdit() == true) {
			this.onEditAction();
		}
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	EnableEdit() {
		if (this.loading == true || this.isProcessing == true) {
			return false;
		} else if (this.SelectedGroupAction == undefined) {
			return false;
		} else if (this.SelectedGroupAction.GroupActionTypeID == 3) {
			return false;
		} else {
			return true;
		}
	}

	ShowNormal() {
		if (this.SelectedGroupAction == null) {
			return true;
		} else if (this.SelectedGroupAction.GroupActionTypeID <= 3 || this.SelectedGroupAction.GroupActionTypeID == 5) {
			return true;
		} else {
			return false;
		}
	}

	ShowPBIS() {
		if (this.SelectedGroupAction != null && this.SelectedGroupAction.GroupActionTypeID == 4) {
			return true;
		} else {
			return false;
		}
	}

	////////////////////////////////////////////
}
